// This preference only hides the temporary notice, never the server's active alerts.
// Remaining quantities and final numbers are deliberately excluded: consuming or
// extending a range must not force a dismissed notice back into the user's work.
export const voucherNoticeKey = alert => JSON.stringify([
  String(alert.id), String(alert.series), Boolean(alert.electronic),
]);

export const createVoucherNoticePreferences = (userId, storageProvider) => {
  const storageKey = userId ? `voucher-notice-dismissed:v1:${userId}` : null;
  const dismissed = new Set();
  const read = () => {
    if (!storageKey) return;
    try {
      const saved = JSON.parse(storageProvider().getItem(storageKey) || "[]");
      if (Array.isArray(saved)) saved.filter(key => typeof key === "string").forEach(key => dismissed.add(key));
    } catch {
      // Storage can be unavailable or malformed; the current session still works.
    }
  };

  return {
    isDismissed(alert) {
      read();
      return dismissed.has(voucherNoticeKey(alert));
    },
    dismiss(alerts) {
      read();
      alerts.forEach(alert => dismissed.add(voucherNoticeKey(alert)));
      if (!storageKey) return;
      try {
        storageProvider().setItem(storageKey, JSON.stringify([...dismissed]));
      } catch {
        // Preserve the in-memory preference when the browser cannot persist it.
      }
    },
  };
};
